<template>
  <div
    class="fixed z-50 bottom-4 right-4 flex flex-col gap-2 items-end"
    aria-live="polite"
    aria-atomic="true"
  >
    <transition-group name="toast" tag="div">
      <div
        v-for="toast in activeToasts"
        :key="toast.id"
        class="min-w-[280px] max-w-[420px] shadow-lg text-white"
        :class="[toast.colorClass, toast.shapeClass]"
        role="status"
      >
        <button
          type="button"
          class="absolute top-2 right-2 text-white/80 hover:text-white focus:outline-none"
          aria-label="Close notification"
          @click="dismissToast(toast.id)"
        >
          ×
        </button>
        <div class="px-4 py-3 pr-8 whitespace-pre-line">
          {{ toast.message }}
        </div>
      </div>
    </transition-group>
  </div>
</template>

<script>
  import EventBus from '@/services/EventBus';

  let nextToastId = 1;

  export default {
    name: 'ToastContainer',
    data() {
      return {
        activeToasts: []
      };
    },
    mounted() {
      EventBus.$on('Toast::Show', this.onShowToast);
    },
    beforeDestroy() {
      EventBus.$off('Toast::Show', this.onShowToast);
    },
    methods: {
      onShowToast(payload) {
        const {
          message,
          colorClass = 'bg-primary',
          shape = 'square',
          durationMs = 5000
        } = payload || {};

        const toastId = nextToastId++;
        const shapeClass = shape === 'square' ? '' : 'rounded-md'

        const toast = {
          id: toastId,
          message,
          colorClass,
          shapeClass
        };

        this.activeToasts.push(toast);

        // Auto-dismiss
        if (durationMs > 0) {
          setTimeout(() => this.dismissToast(toastId), durationMs);
        }
      },
      dismissToast(toastId) {
        this.activeToasts = this.activeToasts.filter(t => t.id !== toastId);
      }
    }
  };
</script>

<style scoped>
.toast-enter-active,
.toast-leave-active {
  transition: all 0.2s ease;
}

.toast-enter,
.toast-leave-to {
  opacity: 0;
  transform: translateY(8px);
}
</style>
